<template>
  <input-facade 
    v-if="options.input_mask" 
    :class="options.css_classes" 
    :mask="options.input_mask" 
    :id="'field-' + options.id" 
    :name="'fields[' + options.id + ']'" 
    :masked="true" 
    :placeholder="options.placeholder_text"
    v-model="fieldValue" />
  <input 
    v-else 
    type="text" 
    :class="options.css_classes" 
    :id="'field-' + options.id" 
    :name="'fields[' + options.id + ']'" 
    :placeholder="options.placeholder_text"
    v-model="fieldValue" />
</template>

<script>
import { InputFacade, tokens } from 'vue-input-facade'

export default { 
  name: 'TextField',
  components: {
    InputFacade
  },
  props: {
    options: {
      type: Object,
      required: true
    },
    value: {
      type: String
    }
  },
  methods: {
    validate () {
      if (this.options.input_mask) {
        if (this.value.length == this.options.input_mask.length) {
          const value = this.value
          Array.from(this.options.input_mask).forEach(function(char, index) {
            if (char in tokens) {
              let token = tokens[char]
              if (!token.pattern.test(value[index])) {
                return false
              }
            }
          })
          return true
        }
      } else {
        return (this.value && this.value != '')
      }
      return false
    }
  },
  computed: {
    isValid () {
      if (this.value && this.value != '') {
        return true
      }
      return false
    },
    fieldValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$commit.setFieldValue({
          key: 'field-' + this.options.id, 
          value: val
        })
      }
    },
    inputMask () {
      if (this.options.input_mask && this.options.input_mask.length) {
        return this.options.input_mask
      }
      return false
    }
  }
}
  
</script>
